/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-17T15:34:14.747
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getPublishOperationLogEditInit,
	getPublishOperationLogView
} from '@api/house/PublishOperationLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getPublishOperationLogEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getPublishOperationLogEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getPublishOperationLogView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getPublishOperationLogView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
